import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants";

export const ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
    {
        key: 'attributeDescription',
        label: 'Nome asset'
    },
    {
        key: 'amount',
        label: 'Importo'
    }
]
